import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
import HeaderCarousel from "../Elements/HeaderCarousel";
// Assets
import HeaderImage from "../../assets/img/header-img.png";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

import Sspmall from '../../assets/img/logo/sspmall.png'
import Android from '../../assets/img/logo/google_download.png'
import Ios from '../../assets/img/logo/ios_download.png'
import { Link } from "react-scroll";

export default function Header() {
  var getUrl = window.location;
  return (
    <Wrapper id="home" className="container flexSpaceCenter">
      <LeftSide className="flexCenter">
        <div className="textCenter">
          <img src={Sspmall} />
          <h1 className="extraBold font60">SUKSAPAN Mall</h1>
          <HeaderP className="font13 semiBold textCenter">
            <p className="font14">ตอบทุกโจทย์ของการศึกษา <br/> สนับสนุนผลิตภัณฑ์เพื่อการเรียนรู้ที่ครบครันและหลากหลาย</p>
          </HeaderP>
          {/* <BtnWrapper>
            <FullButton title="Get Started" />
          </BtnWrapper> */}
          <div className="row">
            <div className="col-6 textRight">
              <a href="https://play.google.com/store/apps/details?id=td.webuild.ssp" target="_blank"><img src={Android} width={'65%'}/></a>
            </div>
            <div className="col-6 textLeft">
            <a href="https://apps.apple.com/us/app/suksapan-mall/id1587123179" target="_blank"><img src={Ios} width={'60%'}/></a>
            </div>
          </div>
        </div>
      </LeftSide>
      <RightSide>
        <ImageWrapper>
          {/* <Img className="radius8" src={`${getUrl}img/slides/Branding-20231018.jpg`} alt="office" style={{zIndex: 9, width:'100%'}} /> */}
          <HeaderCarousel/>
          {/* <QuoteWrapper className="flexCenter darkBg radius8">
            <QuotesWrapper>
              <QuotesIcon />
            </QuotesWrapper>
            <div>
              <p className="font15 whiteColor">
                <em>Friends, such as we desire, are dreams and fables. Friendship demands the ability to do without it.</em>
              </p>
              <p className="font13 orangeColor textRight" style={{marginTop: '10px'}}>Ralph Waldo Emerson</p>
            </div>
          </QuoteWrapper> */}
          {/* <DotsWrapper>
            <Dots />
          </DotsWrapper> */}
        </ImageWrapper>
        <GreyDiv className="lightBg"></GreyDiv>
      </RightSide>
    </Wrapper>
  );
}


const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: 607px;
  }
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: -50px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;


